export class ProxyFormController {

    constructor($scope, xrayProxiesDao, XRayUIModelSaver, $state,JFrogModal) {
        this.proxiesDao = xrayProxiesDao;
        this.modelSaver = XRayUIModelSaver.createInstance(this, ['proxy']);
        this.$state = $state;
        this.modal = JFrogModal;
        $scope.$parent.Settings.showButtons = true;
        $scope.$parent.Settings.currentSubController = this;


        this._getData();
    }

    _getData() {
        this.proxiesDao.get().$promise.then((proxy) => {
            this.proxy = proxy;
            this.modelSaver.save();
        })
    }

    save() {
        let payload = _.cloneDeep(this.proxy);
        this.proxiesDao.test({$suppress_toaster: true},payload).$promise.then((testResponse) => {
            if (testResponse.status == 200) {
                console.log("Test results status is",testResponse.status);
                this.proxiesDao.update({}, payload).$promise.then(() => {
                    this.modelSaver.save();
                });
            }else{
                this.modal.confirm(`Cannot reach proxy <br/> Do you wish to proceed anyway?`)
                    .then(() => {
                        this.proxiesDao.update({}, payload).$promise.then(() => {
                            this.modelSaver.save();
                        });
                    });
            }
        });
    }

    canSave() {
        return this.proxyEditForm.$valid;
    }

    cancel() {
        this.$state.go('home');
    }

    checkLocalHost(retypeVal) {

        if (typeof retypeVal !== 'undefined') {

            if (retypeVal.toLowerCase().indexOf('localhost') > -1 || retypeVal.toLowerCase().indexOf('127.0.0.1') > -1) {

                return false;
            } else {

                return true;
            }
        } else {
            return true;
        }
        //return !retypeVal || (retypeVal && this.input.password === retypeVal);
    }

}



// WEBPACK FOOTER //
// ./modules/xray/states/settings/tabs/proxy/proxy_form.controller.js